import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from 'api/rtk-api'
import { Table } from 'components/core-v2'
import { isSameDay } from 'date-fns'
import { useParams } from 'react-router-dom'
import { displayPercentage } from 'utilities/number'

import { TENANT } from '@/const'

import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'
import { Loading } from './Loading'

export const HoldingsTable = () => {
  const { date: stringDate, source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  if (isLoading) return <Loading />

  const { accountSnapShots } = data

  const snapshot = accountSnapShots.find(snapshot =>
    isSameDay(new Date(snapshot.valuationDate), new Date(stringDate))
  )

  const performanceAmountSum = snapshot.growthAssets.reduce((sum, row) => sum + row.amount, 0)
  const performanceRows = snapshot.growthAssets.map(asset => ({
    ...asset,
    currency: snapshot.notionalCurrency,
    name: asset.assetName,
    performanceType: 'Performance',
    weight: displayPercentage(asset.amount / performanceAmountSum, 2)
  }))
  const protectionRows = snapshot.protectedAssets.map(asset => ({
    ...asset,
    currency: snapshot.notionalCurrency,
    name: asset.assetName,
    weight: '–',
    performanceType: 'Protection'
  }))
  const rowData = [...performanceRows, ...protectionRows]

  return (
    <Table
      showGreyHeader
      agGridProps={{
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44
      }}
      height="400px"
    />
  )
}
